import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { RightBridgeApiService } from '../../../../services/right-bridge-api.service';
import { UnifiedFlowService } from '../../../../unified-flow/unified.service';
import { SessionStorageService } from '../../../../services/session-storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-copy-case',
  templateUrl: './copy-case.component.html',
  styleUrls: ['./copy-case.component.scss'],
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, MatMenuModule],
})
export class CopyCaseComponent {
  @Input() donorCase;
  @Input() rights;
  @Output() toggleLoading = new EventEmitter();

  private rbs = inject(RightBridgeApiService);
  private route = inject(Router);
  private unfFlowSvc = inject(UnifiedFlowService);
  private ss = inject(SessionStorageService);
  private snacky = inject(MatSnackBar);
  dialog = inject(MatDialog);

  async copyCase() {
    const { CopyCaseModalComponent } =
      await import('../../../../unified-flow/copy-case-modal/copy-case-modal.component');
    this.unfFlowSvc.copyCaseId.set(this.donorCase.profileId);
    this.unfFlowSvc.copyFromCaseSearch.set(true);
    const copyCaseDialogRef = this.dialog.open(CopyCaseModalComponent, {
      panelClass: 'copy-case-dialog',
      width: '98vw',
      autoFocus: false,
    });

    copyCaseDialogRef.afterClosed().subscribe(resp => {
      if (resp?.data && resp.data !== 'cancel') {
        this.toggleLoading.emit(true);
        this.unfFlowSvc.copyCaseData.set(resp.data);
        this.rbs
          .newProfile({ 'Profile.Description': '' }, true)
          .subscribe({
            next: x => {
              this.toggleLoading.emit(false);
              if (!this.rights?.includes('ReadOnly')) {
                this.route.navigate([`/case/rb/${x.results}/0`]);
              } else {
                this.rbs.getQuestions(x.results).subscribe(data => {
                  const profile = this.getUniqueId(3);
                  this.ss.set('noSave', {
                    id: profile,
                    profile: null,
                    questionnaire: data.results.questionnaire,
                  });

                  this.route.navigate([`/case/rb/${profile}/0`]);
                });
              }
            },
            error: () => {
              this.snacky.open(
                'Oops! Something went wrong. Please try again.',
                'Close',
                { duration: 4000 }
              );
              this.toggleLoading.emit(false);
            },
          });
      }
    });
  }

  getUniqueId(parts: number): string {
    const stringArr = [];
    for (let i = 0; i < parts; i++) {
      const S4 = (((1 + Math.random()) * 0x10000) | 0)
        .toString(16)
        .substring(1);
      stringArr.push(S4);
    }
    return stringArr.join('-');
  }
}
